import { all, fork } from 'redux-saga/effects';
import { watchTemplateVariableSaga } from './saga';
export function* variableTemplateRootSaga() {
    yield all([
        fork(watchTemplateVariableSaga)
    ]);
}
